import { useCallback } from 'react';
import { useHistory } from 'hooks/generic/useHistory';
import { useIsImportBlockchainNft } from './useIsImportBlockchainNft';

export const useOpenNftView = () => {
  const { push } = useHistory();
  const isImportBlockchainNft = useIsImportBlockchainNft();

  const handleOpenNft = useCallback((nftUrlKey: string) => {
    return isImportBlockchainNft ? undefined : push(`/nfts/${nftUrlKey}`);
  }, []);

  return { handleOpenNft };
};
